import React, { createContext, useContext, useState } from 'react';

interface TopicGroupInclusionContextState {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  selectedTopicGroupIds: string[];
  setSelectedTopicGroupIds: (ids: string[]) => void;
  /**
   * Used to store the original topic group ids when the modal is opened. We need to track topics that are deselected so we can remove them from the topic group
   */
  originalTopicGroupIds: string[];
  setOriginalTopicGroupIds: (ids: string[]) => void;
}

const TopicGroupContext = createContext<TopicGroupInclusionContextState | undefined>(undefined);

export function TopicGroupInclusionProvider({ children }: { children: React.ReactNode }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTopicGroupIds, setSelectedTopicGroupIds] = useState<string[]>([]);
  const [originalTopicGroupIds, setOriginalTopicGroupIds] = useState<string[]>([]);

  return (
    <TopicGroupContext.Provider
      value={{
        modalOpen,
        setModalOpen,
        selectedTopicGroupIds,
        setSelectedTopicGroupIds,
        originalTopicGroupIds,
        setOriginalTopicGroupIds
      }}
    >
      {children}
    </TopicGroupContext.Provider>
  );
}

export const useEditTopicGroupContext = () => {
  const context = useContext(TopicGroupContext);
  if (!context) {
    throw new Error('useEditTopicGroupContext must be used within a TopicGroupInclusionProvider');
  }
  return context;
};
